angular.module('SpidApp')

.constant('AgencyAdapterConfig', {
  name : 'Agency',
  fields : [
    {
    	local   : 'id',
    	distant : 'id'
    }, {
    	local   : 'name',
    	distant : 'country'
    }, {
    	local   : 'code_regate',
    	distant : 'code_agence'
    }, {
    	local   : 'mail',
    	distant : 'mail'
    }, {
    	local   : 'currency_id',
    	distant : 'id_currency'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }
  ]
}) 
